import React from "react";
import ReactAvatar, { ReactAvatarProps } from "react-avatar";
import { withTheme } from "@material-ui/core";
import { ThemeType } from "@theme";
import { removeEmoji } from "@bonliva-crm/common";

export type AvatarProps = Partial<Omit<ReactAvatarProps, "size">> & {
  size?: "micro" | "mini" | "small" | "medium" | "big" | "large";
};

type Props = AvatarProps & {
  theme: ThemeType;
};

type State = {
  src: string;
};

export class Avatar extends React.Component<Props, State> {
  state = { src: "" };

  img: HTMLImageElement;

  componentDidMount() {
    this.checkImageExists(this.props.src);
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props): void {
    if (this.props.src !== nextProps.src) {
      this.checkImageExists(nextProps.src);
    }
  }

  componentWillUnmount() {
    this.img = null;
  }

  checkImageExists = (src: string) => {
    if (!src) {
      return;
    }

    this.img = new Image();
    this.img.src = src;
    this.img.onload = () => this.img && this.setState({ src });
    this.img.onerror = () => this.img && this.setState({ src: "" });
  };

  render() {
    const { size = "medium", theme, onClick, name, className, ...props } = this.props;
    const { src } = this.state;

    return (
      <ReactAvatar
        round={true}
        size={theme.avatars[size].width.toString()}
        maxInitials={3}
        style={theme.avatar}
        onClick={onClick}
        src={src}
        name={removeEmoji(name || "")}
        {...props}
      />
    );
  }
}

export default withTheme(Avatar);
